import { MenuItem, Stack } from '@mui/material';
import styled from 'styled-components';

import { TStyledMenuItemProps } from '@/shared/components/ui/menu-item/menu-item.types';

export const StyledMenuItem = styled(MenuItem)<TStyledMenuItemProps>`
  && {
    padding: 0 0.5rem;
    background-color: transparent;
    transition: background-color 0.1s ease-in-out;
    border-radius: ${({ theme }) => theme.shape.buttonRadius.extraSmall};
    height: ${({ theme }) => theme.shape.buttonHeight.extraSmall};
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    width: 100%;
    ${({ theme }) => theme.typography.p8};

    svg {
      max-width: 1.25rem;
      max-height: 1.25rem;
      min-width: 1.25rem;
    }

    /* Content must ellipsise instead of widening the row: an oversized option
       scrolls the virtualised select listbox sideways. */
    * {
      min-width: 0;
    }

    .MuiTypography-root {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    & > div {
      color: ${({ theme, $variant }) =>
        $variant === 'alert'
          ? theme.palette.danger.main
          : theme.palette.text.primary};
    }

    &:hover {
      background-color: ${({ theme }) =>
        theme.palette.background.clickableHover};

      .MuiCheckbox-root:not(.Mui-checked) > svg {
        color: ${({ theme }) => theme.palette.stroke.secondary};
      }
    }

    .MuiCheckbox-root {
      flex-shrink: 0;
      margin: 0 -0.5rem;
    }
  }
`;

export const MainContent = styled(Stack)<TStyledMenuItemProps>`
  && {
    flex-direction: row;
    gap: 0.5rem;
    align-items: center;

    svg {
      color: ${({ theme, $variant }) =>
        $variant === 'alert'
          ? theme.palette.danger.main
          : theme.palette.primary.main};
    }
  }
`;

export const SelectablePlaceholder = styled.div`
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
`;
